import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import posthog from 'posthog-js'
import Button from '../../components/Buttons/BaseButton'
import MessageNotice from '../../components/MessageNotice/MessageNotice'
import Select from '../../components/Inputs/Select'
import {
  SUPPORT_CATEGORY,
  SUPPORT_CATEGORY_OPTIONS,
  SUPPORT_TOPIC_PREFILL,
} from '../../config/settings/support'
import {
  onCreateSupportTicketAsync,
  resetSupportCreateState,
} from './Support.slice'
import PagePanel from '../../components/Layouts/PagePanel'
import {
  Field,
  FieldLabel,
  Form,
  TextArea,
  TrackingCode,
} from './Support.styles'

const SupportForm = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const { status, error, createSuccess, lastCreatedTrackingCode } = useSelector(
    (state) => state.support
  )
  const topic = searchParams.get('topic')
  const topicPrefill = topic ? SUPPORT_TOPIC_PREFILL[topic] : null

  const [category, setCategory] = useState(
    topicPrefill?.category || SUPPORT_CATEGORY.SUPPORT
  )
  const [message, setMessage] = useState(topicPrefill?.message || '')
  const [validationError, setValidationError] = useState('')

  useEffect(() => {
    if (!topicPrefill) return
    setCategory(topicPrefill.category)
    setMessage(topicPrefill.message)
  }, [topicPrefill])

  useEffect(() => {
    return () => {
      dispatch(resetSupportCreateState())
    }
  }, [dispatch])

  const handleSubmit = (event) => {
    event.preventDefault()
    const trimmed = message.trim()
    if (!trimmed) {
      setValidationError('Escribe un mensaje antes de enviar.')
      return
    }
    if (trimmed.length < 10) {
      setValidationError('El mensaje debe tener al menos 10 caracteres.')
      return
    }

    setValidationError('')
    dispatch(onCreateSupportTicketAsync({ category, message: trimmed }))
      .unwrap()
      .then(() => {
        posthog.capture('support_ticket_submitted', { category })
        setMessage('')
        setCategory(SUPPORT_CATEGORY.SUPPORT)
      })
      .catch(() => undefined)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Select
        label="Tipo"
        name="category"
        value={category}
        options={SUPPORT_CATEGORY_OPTIONS}
        onChange={(event) => setCategory(event.target.value)}
      />
      <Field>
        <FieldLabel htmlFor="support-message">Mensaje</FieldLabel>
        <TextArea
          id="support-message"
          name="message"
          value={message}
          onChange={(event) => {
            setMessage(event.target.value)
            setValidationError('')
          }}
          placeholder="Cuéntanos qué necesitas…"
        />
      </Field>

      {validationError && (
        <MessageNotice type="warning">{validationError}</MessageNotice>
      )}
      {status.create === 'failed' && error && (
        <MessageNotice type="error">{error}</MessageNotice>
      )}
      {createSuccess && (
        <MessageNotice type="success">
          Mensaje enviado.
          {lastCreatedTrackingCode ? (
            <>
              {' '}
              Tu código de seguimiento es{' '}
              <TrackingCode>{lastCreatedTrackingCode}</TrackingCode>. Guárdalo
              para referenciar este caso.
            </>
          ) : (
            ' Queda registrado y lo revisaremos pronto.'
          )}
        </MessageNotice>
      )}

      <Button type="submit" loading={status.create === 'loading'} width="180px">
        Enviar
      </Button>
    </Form>
  )
}

const SupportHelpContainer = () => {
  return (
    <PagePanel
      title="Contacto"
      body="Escribe con tranquilidad: soporte, un comentario o una consulta comercial. Queda registrado para hacer seguimiento."
    >
      <SupportForm />
    </PagePanel>
  )
}

export default SupportHelpContainer
